<div class="showcase-grid">
  <div class="showcase-row" data-showcase-id="cs-scanner-hints">
    <cs-label>cs-scanner-hints</cs-label>
    <cs-scanner-hints [hints]="scannerHints"></cs-scanner-hints>
  </div>

  <div class="showcase-row" data-showcase-id="cs-scanner-model-picker">
    <cs-label>cs-scanner-model-picker</cs-label>
    <cs-scanner-model-picker [modelOptions]="scannerModels" [selectedModel]="scannerModel"
      (modelSelected)="scannerModel = $event"></cs-scanner-model-picker>
  </div>

  <div class="showcase-row" data-showcase-id="cs-scanner-photo-reel">
    <cs-label>cs-scanner-photo-reel</cs-label>
    <cs-scanner-photo-reel [photos]="samplePhotos" [maxSlots]="4" [canAdd]="true"></cs-scanner-photo-reel>
  </div>

  <div class="showcase-row" data-showcase-id="cs-scanner-shutter-bar">
    <cs-label>cs-scanner-shutter-bar</cs-label>
    <cs-scanner-shutter-bar></cs-scanner-shutter-bar>
  </div>

  <div class="showcase-row" data-showcase-id="cs-scanner-analyzing-overlay">
    <cs-label>cs-scanner-analyzing-overlay</cs-label>
    <div class="showcase-box">
      <cs-scanner-analyzing-overlay statusText="Analyzing your meal..." [progress]="40"></cs-scanner-analyzing-overlay>
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-scanner-permission-denied">
    <cs-label>cs-scanner-permission-denied (its blocked-camera report goes to a stand-in, so nothing is sent)</cs-label>
    <cs-test-permission-denied-demo></cs-test-permission-denied-demo>
  </div>
</div>
